import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { Row, Col } from 'reactstrap';
import { Select, Button, Modal, Divider, Switch } from 'antd';
import SideMenu from '../../components/SideMenu';
import Loading from '../../components/Loading';
import SupplierGrid from '../../components/grids/SupplierGrid';
import './SupplierCapabilties.scss';

export default class SupplierCapabilities extends Component {
  static propTypes = {
    auth: PropTypes.shape({
      id: PropTypes.string,
      role: PropTypes.string,
      jwtToken: PropTypes.string,
      expiration: PropTypes.number,
      organizationId: PropTypes.string,
      email: PropTypes.string,
      cageCode: PropTypes.string,
      permissions: PropTypes.number,
    }).isRequired,
    supplierSelections: PropTypes.object.isRequired,
    supplierSearchCriteria: PropTypes.object.isRequired,
    supplierSearchMenuSwitch: PropTypes.object.isRequired,
    supplierSearchMenuSelect: PropTypes.object.isRequired,
    supplierSearchMenuCamelCase: PropTypes.object.isRequired,
    options: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    supplierAggs: PropTypes.object.isRequired,
    supplierHits: PropTypes.number.isRequired,
    deselect: PropTypes.func.isRequired,
    clearAll: PropTypes.func.isRequired,
    downloadCsv: PropTypes.func.isRequired,
    openModal: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    supplierList: PropTypes.array.isRequired,
    getSelectedSuppliers: PropTypes.func.isRequired,
    selectAll: PropTypes.number.isRequired,
    changeSelectAllValue: PropTypes.func.isRequired,
    rawSelected: PropTypes.object.isRequired,
    modalOpen: PropTypes.bool.isRequired,
    handleOkRfq: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,
    newRfq: PropTypes.bool.isRequired,
    selectedRfq: PropTypes.string,
    onRadioChange: PropTypes.func.isRequired,
    onSelectChange: PropTypes.func.isRequired,
    modalVisible: PropTypes.bool.isRequired,
    closeGModal: PropTypes.func.isRequired,

  };
  static defaultProps = {
    selectedRfq: null,
  };



  render() {
    const {
      auth,
      supplierSelections,
      supplierSearchCriteria,
      supplierSearchMenuSwitch,
      supplierSearchMenuSelect,
      supplierSearchMenuCamelCase,
      options,
      onChange,
      supplierAggs,
      supplierHits,
      deselect,
      clearAll,
      downloadCsv,
      openModal,
      loading,
      supplierList,
      getSelectedSuppliers,
      selectAll,
      changeSelectAllValue,
      rawSelected,
      modalOpen,
      handleOkRfq,
      closeModal,
      newRfq,
      selectedRfq,
      onRadioChange,
      onSelectChange,
      modalVisible,
      closeGModal,
    } = this.props;

    let values;
    console.log("values / supplierSelections", supplierSelections);
    if (supplierSelections) {
      values = Object.keys(supplierSelections);
    } else {
      values = [];
    }

    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>NFFS ICON - Supplier Capabilities Search Page</title>
          <meta
            name="description"
            content="Search the ICON Portal casting supplier database to locate foundries that manufacture metal castings and parts for the defense industry."
          />
          <meta
            name="keywords"
            content="foundry database, metal casting database, icon portal, defense-related castings"
          />
        </Helmet>

        <Row style={{ flexWrap: 'nowrap', marginRight: 0 }}>
          <Col xs={3} className="nf-account-admin__side-panel">
            <SideMenu
              onChange={onChange}
              supplierAggs={supplierAggs}
              supplierSearchCriteria={supplierSearchCriteria}
              supplierSearchMenuSwitch={supplierSearchMenuSwitch}
              supplierSearchMenuSelect={supplierSearchMenuSelect}
              supplierSearchMenuCamelCase={supplierSearchMenuCamelCase}
            />
          </Col>
          <Col>
            <div className="nf-supplier-search-clear-all">
              <Row
                style={{
                  'padding-bottom': '6px',
                }}
              >
                {/* <!-- HEADER --> */}
                <Col xs={1} />
                <Col
                  xs={2}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    fontWeight: 600,
                    fontSize: '16px',
                  }}
                >
                  {supplierHits} supplier(s) found
                </Col>
                <Col
                  xs={4}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <Select
                    mode="multiple"
                    style={{ width: '100%' }}
                    placeholder="Search Criteria"
                    optionLabelProp="label"
                    value={values}
                    dropdownStyle={{ display: 'none' }}
                    disabled={!values[0]}
                    onDeselect={e => {
                      deselect(e);
                    }}
                  />
                </Col>
                <Col xs={1}>
                  <Button onClick={clearAll} type="primary">
                    Clear All
                  </Button>
                </Col>
                <Col xs={2}>
                  {(auth.role === 'GOVERNMENT_USER' ||
                    auth.role === 'SUPER_ADMIN') && (
                      <Button onClick={downloadCsv} type="primary">
                        Download Results
                      </Button>
                    )}{' '}
                </Col>
                <Col>
                  {/*  {this.state.iconMember && this.props.auth.role !== 'GOVERNMENT_USER' && ( */}
                  <Button id="sendRFQ"
                    onClick={openModal}
                    type="primary"
                    style={{
                      background: '#ff7c52',
                      border: '#ff7c52',
                      borderRadius: '6px',
                    }}
                  >
                    Send RFQ
                  </Button>
                  {/* )}   */}
                </Col>
              </Row>
            </div>

            {loading && (
              <Loading text="Finding Suppliers that match your requirements" />
            )}
            {!loading && (
              <SupplierGrid
                suppliers={supplierList}
                getSelectedSuppliers={getSelectedSuppliers}
                selectAll={selectAll}
                changeSelectAllValue={changeSelectAllValue}
                rawSelected={rawSelected}
                iconMember={supplierSearchCriteria.iconMember}
              // foundry={foundry}
              />
            )}
          </Col>
        </Row>
        {/* TODO: probably should break this out to its own component */}
        <Modal
          title="Send RFQ"
          visible={modalOpen}
          onOk={handleOkRfq}
          onCancel={closeModal}
          footer={[
            <Button key="back" onClick={closeModal}>
              Return
            </Button>,
            <Button
              key="submit"
              type="primary"
              disabled={!newRfq && !selectedRfq}
              onClick={handleOkRfq}
            >
              Proceed
            </Button>,
          ]}
        >
          <Switch onClick={onRadioChange} checked={newRfq} />{' '}
          Create a new RFQ
          <Divider plain>Or</Divider>
          <p>Select an Existing RFQ</p>
          <Select
            value={selectedRfq}
            style={{ width: '80%' }}
            onChange={onSelectChange}
            allowClear
          >
            {options}
          </Select>
          <Button />
        </Modal>
        <Modal
          visible={modalVisible}
          title='Warning'
          type='warning'
          style={{ top: '40' }}
          onOk={closeGModal}
          onCancel={closeGModal}
        >
          Government users with RFQ Capabilities must be members of a RFQ Group to submit RFQs. Please contact < a href="mailto:support@nffs.org?Subject=Registration RFQ Group" target="_top"> ICON Support</a > to be added to a RFQ Group if you are an authorized procurement officer.
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/SupplierCapabilities/SupplierCapabilities.jsx